// 封装sessionstorage存取token

const key = 'G-Application-Token';
const uidKey = 'G-Application-uid';

// 存token至sessionstorage
const setToken = (token: string) => {
  return window.localStorage.setItem(key, token);
};

// 从sessionstorage中取token
const getToken = () => {
  return window.localStorage.getItem(key);
};

const setUid = (uid: string) => {
  return window.localStorage.setItem(uidKey, uid);
};

// 从sessionstorage中取token
const getUid = () => {
  return window.localStorage.getItem(uidKey);
};

//从sessionstorage中删除token
const removeToken = () => {
  return window.localStorage.removeItem(key);
};
const removeUid = () => {
  return window.localStorage.removeItem(uidKey);
};


export { setToken, getToken, removeToken, removeUid, setUid, getUid };
